<cpd-dialog-container
  dialogTitle="{{ data.title }}"
  [isCloseIconVisible]="true"
>
  @if (data.videoResource) {
    <div class="align-center flex">
      @if (mp4Video) {
        <video
          #mp4Video
          controls
          width="100%"
          type="video/mp4"
          [src]="data.videoResource"
        >
          @if (data.videoSubtitleUrl) {
            <track
              srclang="en"
              label="English"
              kind="captions"
              [src]="data.videoSubtitleUrl"
            />
          }
        </video>
      } @else {
        <vg-player class="mt-3 h-auto" (onPlayerReady)="onPlayerReady($event)">
          <vg-overlay-play></vg-overlay-play>
          <vg-buffering></vg-buffering>

          <vg-controls>
            <vg-play-pause></vg-play-pause>

            <vg-scrub-bar>
              <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
              <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
            </vg-scrub-bar>

            <vg-time-display
              vgProperty="left"
              vgFormat="mm:ss"
            ></vg-time-display>

            @if (bitrates) {
              <vg-quality-selector
                (onBitrateChange)="setBitrate($event)"
                [bitrates]="bitrates"
                class="font-sans focus:outline-none"
              >
              </vg-quality-selector>
            }

            <vg-mute></vg-mute>
            <vg-volume></vg-volume>

            <vg-fullscreen></vg-fullscreen>
          </vg-controls>

          <video
            #media
            (onGetBitrates)="bitrates = $event"
            [vgMedia]="media"
            [vgHls]="data.videoResource"
            id="singleVideo"
            crossorigin
          >
            @if (data.videoSubtitleUrl) {
              <track
                default
                srclang="en"
                label="English"
                kind="captions"
                [src]="data.videoSubtitleUrl"
              />
            }
          </video>
        </vg-player>
      }
    </div>
  }
</cpd-dialog-container>
